import {Text} from './utils';

export default class StatHUD extends PIXI.Container {
	constructor(updateTime = 1000) {
		super();

		this._updateTime = updateTime;
		this._lastUpdate = Date.now();
		this._statText = null;
		this.init();
	}

	init() {
		const header = Text(
			'Geometries: \nTextures: \nDrawcalls: \nPoints: \nTriangles: ',
			{font: '32px Ahkio Regular', align: 'right'});

		header.tint = 0xFFFFFF;
		header.anchor.set(0.5);
		header.position.set(-750, 280);
		this.addChild(header);

		this._statText = Text(
			'0 \n0 \n0 \n0 \n0 ',
			{font: '32px Ahkio Regular', align: 'left'});
		this._statText.tint = 0xFF4444;
		this._statText.anchor.set(0, 0.5);
		this._statText.position.set(-670, 280);
		this.addChild(this._statText);
	}

	destroy() {
		super.destroy();
	}

	update(info) {
		if ((Date.now() - this._lastUpdate) > this._updateTime) {
			this._lastUpdate = Date.now();
			this.updateText(info);
		}
	}

	updateText(info) {
		const geometries 	= info.memory.geometries;		// geometries in memory
		const textures 		= info.memory.textures;			// textures in memory
		const drawcalls 	= info.render.calls;			// WebGL Drawcalls (excl. PIXI)
		const points		= info.render.points;
		const tris			= info.render.triangles;

		this._statText.text = `
			${geometries}
			${textures}
			${drawcalls}
			${points}
			${tris}
		`;
	}
}
